import React from 'react';
import { motion } from 'framer-motion';
export function CaseStudy() {
  return <section id="proof" className="py-24 border-b border-stone-300" data-id="element-856">
      <div className="max-w-6xl mx-auto px-6" data-id="element-857">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-858">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-859">
            Proof Point
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-6 max-w-3xl" data-id="element-860">
            The Moon Palace playbook
          </h2>

          <p className="text-lg text-stone-600 leading-relaxed mb-16 max-w-2xl" data-id="element-861">
            Moon Palace / Palace Resorts built an internal instant quoting
            portal. The results transformed their group segment economics.
            BlockQuote packages this proven playbook for every resort group.
          </p>

          {/* Metrics Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-stone-300 mb-24" data-id="element-862">
            <div className="p-8 border-b md:border-b lg:border-b-0 md:border-r border-stone-300" data-id="element-863">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-864">
                Wholesale Leakage Reduced
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-865">
                15–25<span className="text-red-600" data-id="element-866">%</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-867">
                Estimated leakage shifted to direct (management estimate)
              </p>
            </div>

            <div className="p-8 border-b md:border-b lg:border-b-0 lg:border-r border-stone-300" data-id="element-868">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-869">
                Estimated Annual Savings
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-870">
                $6.0M<span className="text-red-600" data-id="element-871">+</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-872">
                Per resort group at base case adoption (estimate)
              </p>
            </div>

            <div className="p-8 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-873">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-874">
                Quoting Velocity
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-875">
                &lt;1<span className="text-sm ml-1" data-id="element-876">min</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-877">Down from 48–72 hours</p>
            </div>

            <div className="p-8" data-id="element-878">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-879">
                Conversion Lift
              </p>
              <p className="font-mono text-5xl text-stone-900 mb-3" data-id="element-880">
                ↑<span className="text-red-600" data-id="element-881">Higher</span>
              </p>
              <p className="text-sm text-stone-500" data-id="element-882">
                Speed wins group business
              </p>
            </div>
          </div>

          {/* DestaWed Story */}
          <div className="bg-stone-100 border border-stone-300 p-8 md:p-12" data-id="element-883">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-884">
              <div data-id="element-885">
                <div className="inline-block px-3 py-1 bg-red-600 text-white font-mono text-xs uppercase tracking-widest mb-6" data-id="element-886">
                  BlockQuote Investor
                </div>
                <h3 className="font-serif text-3xl text-stone-900 mb-4" data-id="element-887">
                  DestaWed: From Agency to Industry Leader
                </h3>
                <p className="text-lg text-stone-600 leading-relaxed mb-8" data-id="element-888">
                  DestaWed used BlockQuote's instant quoting infrastructure to
                  become the largest agency on record for Moon Palace resort
                  group. Their ability to quote instantly, hold inventory, and
                  present professional proposals gave them a massive competitive
                  advantage.
                </p>
                <blockquote className="border-l-2 border-red-600 pl-6 italic text-stone-700" data-id="element-889">
                  "BlockQuote fundamentally changed how we sell. We don't wait
                  days for pricing anymore — we close the group while they're
                  still excited on the first call."
                </blockquote>
              </div>

              <div className="grid grid-cols-2 gap-px bg-stone-300 border border-stone-300" data-id="element-890">
                <div className="bg-stone-50 p-6" data-id="element-891">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-892">
                    Status
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-893">
                    #1 Agency
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-894">
                    Largest on record for Moon Palace
                  </p>
                </div>
                <div className="bg-stone-50 p-6" data-id="element-895">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-896">
                    Volume
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-897">
                    3x Growth
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-898">
                    Group bookings volume increase
                  </p>
                </div>
                <div className="bg-stone-50 p-6" data-id="element-899">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-900">
                    Partnership
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-901">
                    Investor
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-902">
                    Strategic investor in BlockQuote
                  </p>
                </div>
                <div className="bg-stone-50 p-6" data-id="element-903">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-904">
                    Speed
                  </p>
                  <p className="font-serif text-2xl text-stone-900 mb-1" data-id="element-905">
                    &lt;2 min
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-906">
                    Average quote-to-proposal time
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Source citation */}
          <p className="font-mono text-xs text-stone-400 mt-6" data-id="element-907">
            Source: Internal case study / management estimates
          </p>
        </motion.div>
      </div>
    </section>;
}